<su-headline h="h1" skin="primary">{{
  'speedikon.title' | translate
}}</su-headline>

<div class="location-width">
  <formly-form
    [form]="form"
    [fields]="formFields"
    [model]="formModel"></formly-form>
</div>

<div style="margin-bottom: 20px">
  <mat-slide-toggle
    [(ngModel)]="toggleInactive"
    class="margin"
    [color]="'primary'"
    [hideIcon]="true"
    (change)="onToggleChange($event)"
    >{{ 'speedikon.toggle_inactive' | translate }}</mat-slide-toggle
  >
</div>

<div class="card-container">
  <div class="containers">
    <su-card [card]="cardArchitecture" class="content-card-override">
      <div card-content style="min-width: 265px">
        <mat-tree [dataSource]="treeDataSource()" [treeControl]="treeControl">
          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding>
            <button
              mat-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon>
                {{
                  treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                }}
              </mat-icon>
            </button>
            <a (click)="onNodeClick(node)" class="pointer">{{ node.name }}</a>
          </mat-tree-node>

          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <a (click)="onNodeClick(node)" class="pointer node-padding">{{
              node.name
            }}</a>
          </mat-tree-node>
        </mat-tree>

        <span *ngIf="treeDataSource().data.length === 0">{{
          'accountingArea.accounting_areas.select_location' | translate
        }}</span>
      </div>
    </su-card>
    <div *ngIf="showDiv()" class="wrapper-content-documents">
      <div>
        <app-documents
          [buildingDocument]="buildingDocument()"
          [hasDocumentTypeSelection]="false"
          [hasDocumentVisibilitySelection]="false"
          [defaultDocumentTypeValue]="defaultDocumentTypeValue"
          [defaultDocumentVisibilityValue]="defaultDocumentVisibilityValue" />
      </div>
    </div>
  </div>
</div>

<app-spinner-overlay [show]="isLoading()" [label]="''"></app-spinner-overlay>
